import { TextField as MuiTextField } from '@mui/material'
import type { FieldMeta } from '@crm/shared'

interface DateFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

export function DateField({ field, value, mode, onChange, error, disabled, hideLabel }: DateFieldProps) {
  if (mode === 'view') {
    if (value == null) return <span />
    return <span>{String(value)}</span>
  }

  return (
    <MuiTextField
      label={hideLabel ? undefined : field.label}
      type="date"
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value || undefined)}
      error={!!error}
      helperText={error}
      disabled={disabled}
      required={!!field.is_required}
      size="small"
      fullWidth
      slotProps={{ inputLabel: { shrink: true } }}
    />
  )
}
